<template>
  <main class="body" role="main" id="main">
    <sc-placeholder tag="section" :rendering="rendering" name="locations-list-layout"/>
  </main>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue'
import UIMixin from '~/mixins/ui'

export default {
  name: 'LocationsPage',
  authenticated: true,
  props: {
    rendering: {
      type: Object
    }
  },
  components: {
    scPlaceholder: Placeholder
  },
  mixins: [
    UIMixin
  ]
}
</script>
